<template>
    <path d="M1 1H7V7H1V1Z" fill="none" stroke="#6E9207" stroke-width="2" />
    <path d="M3.5 3.5H4.5V4.5H3.5V3.5Z" fill="#211A4D" stroke="#6E9207" />
    <path d="M11 1H17V7H11V1Z" fill="none" stroke="#DF9E00" stroke-width="2" />
    <path d="M13.5 3.5H14.5V4.5H13.5V3.5Z" fill="#211A4D" stroke="#DF9E00" />
    <path d="M1 11H7V17H1V11Z" fill="none" stroke="#FF7539" stroke-width="2" />
    <path d="M3.5 13.5H4.5V14.5H3.5V13.5Z" fill="#211A4D" stroke="#FF7539" />
    <path d="M10 10H13V13H10V10Z" fill="#211A4D" />
    <path d="M13 12H15V14H13V12Z" fill="#211A4D" />
    <path d="M12 14H14V15H12V14Z" fill="#211A4D" />
    <path d="M10 15H14V16H10V15Z" fill="#211A4D" />
    <path d="M10 16H12V18H10V16Z" fill="#211A4D" />
    <path d="M15 10H18V12H15V10Z" fill="#211A4D" />
    <path d="M16 14H18V16H16V14Z" fill="#211A4D" />
    <path d="M14 16H18V18H14V16Z" fill="#211A4D" />
</template>
